import styled from 'styled-components';
import { secondaryFont } from 'components/mixins/typography';

export const CheckListWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 49px;
    flex-direction: column;
`

export const CheckButtonWrapper = styled.div`
    flex: 0 32px;
    height: 32px;
    margin-right: 25px;
`;

export const TextContent = styled.div`
    box-sizing: border-box;
    width: 100%;
    padding-left: 57px;

    & > ul {
        padding-left: 0;

        & > li:before {
            display: none;
        }
    }
`;

export const TextTitle = styled.span`
    ${secondaryFont}
    color: ${props => props.theme.colors.textColor};
    font-size: 22px;
    font-weight: 600;
    line-height: 1.4;
`


export const ChecklistItemTitle = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 16px;
`;
